import { connectDatabaseEmulator, getDatabase } from 'firebase/database';
import { connectStorageEmulator, getStorage } from 'firebase/storage';
import { app } from './client';
import { db } from './firestoreClient';
import { functions } from './functionsClient';

export { db };
export const storage = getStorage(app);
export const database = getDatabase(app);

if (typeof window !== 'undefined' && ['localhost', '127.0.0.1'].includes(window.location.hostname)) {
  const host = window.location.hostname;
  connectStorageEmulator(storage, host, 9199);
  connectDatabaseEmulator(database, host, 9000);
}

export { functions };
